import { render, staticRenderFns } from "./SelectUserPermissions.vue?vue&type=template&id=743ff04e&"
import script from "./SelectUserPermissions.vue?vue&type=script&lang=js&"
export * from "./SelectUserPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports